import type { CursorPage } from "../../schemas/venue";

/** Default page sizes for the admin and venue-portal keyset lists (server max is 100). */
export const ADMIN_VENUES_PAGE_SIZE = 50;
export const VENUE_CLOSURES_PAGE_SIZE = 100;

/**
 * TanStack's `getNextPageParam`: the next cursor to request, or `undefined`
 * (its "stop" value) once the server reports there is no more.
 */
export function nextPageParam<T>(lastPage: CursorPage<T>): string | undefined {
	return lastPage.nextCursor ?? undefined;
}

/** Flattens an infinite query's pages into one list, in server order. */
export function flattenPages<T>(pages: readonly CursorPage<T>[] | undefined): T[] {
	return (pages ?? []).flatMap((page) => page.items);
}
